import React, { useState } from "react";
import { styled } from "../../../../stitches.config";

import WithLazyLoad from "../../../HOCs/WithLazyLoad";
import ConditionalWrapper from "../../../../helpers/ConditionalWrapper";

import shareIcon from "../../../../redesign/assets/icons/socialbutton-share-black.svg";

const TiktokEmbed = ({ videoId, noWrapper }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <ConditionalWrapper
      condition={!noWrapper}
      wrapper={(children) => (
        <WithLazyLoad
          options={{
            height: 740,
            once: true,
            offset: 600,
          }}
        >
          {children}
        </WithLazyLoad>
      )}
    >
      <EmbedWrapper>
        {!loaded && (
          <Placeholder>
            <PlaceholderIcon />
          </Placeholder>
        )}

        <Iframe
          src={`https://www.tiktok.com/embed/v2/${videoId}`}
          loading="lazy"
          allow="encrypted-media;"
          allowFullScreen
          scrolling="no"
          onLoad={() => setLoaded(true)}
          $loaded={loaded}
        />
      </EmbedWrapper>
    </ConditionalWrapper>
  );
};

export default TiktokEmbed;

const EmbedWrapper = styled("div", {
  height: "100%",
  aspectRatio: "9 / 16",
  maxWidth: "605px",
  margin: "20px auto",
  position: "relative",
  //minHeight: "740px",
  overflow: "hidden",
  borderRadius: "4px",
  background: "#f3f3f3",
  maxHeight: "746px",
  iframe: {
    display: "block",
  },

  "@bp4": {
    maxHeight: "auto",
    minHeight: "758px",
    width: "100%",
    height: "auto",
    aspectRatio: "9 / 16",
    borderRadius: "12px",
  }

});

const Placeholder = styled("div", {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background:
    "linear-gradient(180deg, rgba(245,245,245,1) 0%, rgba(235,235,235,1) 100%)",
  zIndex: 1,
});

const PlaceholderIcon = styled("div", {
  width: "80px",
  height: "80px",
  background: `transparent url("${shareIcon}") no-repeat center center`,
  backgroundSize: "contain",
  opacity: 0.4,
});

const Iframe = styled("iframe", {
  width: "100%",
  height: "100%",
  border: 0,
  position: "absolute",
  inset: 0,
  transition: "opacity 250ms ease",
  variants: {
    $loaded: {
      true: {
        opacity: 1,
      },
      false: {
        //opacity: 0,
      },
    },
  },

  defaultVariants: {
    $loaded: false,
  },
});